import { getOnlyNumber } from './converters'

export function isFullCardNumber(value: string) {
    return getOnlyNumber(value).toString().length === 19
}

export function isCompleteExpDate(value: string) {
    return getOnlyNumber(value).toString().length === 4
}
